export default "__VITE_ASSET__BoVd1Eq6__"